export{ SvatekProps } from "./svatek.props";
export const name = "SvatekComponent";

